import { Element } from './Element'

export class DescElement extends Element {
  override type = 'desc'
}
